import Vue from 'vue';
import atom from '@tencent/vft-atom';
import Cookie from 'js-cookie';
import { removeHttp } from '@vip-activity/utils';
import { AccountType, TypeUserService } from './index.interface';
import loginService from '../loginService/index';

export class UserService implements TypeUserService {
  isInited = false

  nick = ''

  headurl = ''

  type = AccountType.notlogin

  id = ''

  vuid = 0

  async init(): Promise<void> {
    await loginService.init();
    loginService.onLoginStateChange(async () => {
      await this.refresh();
    });
    await this.refresh();
    this.isInited = true;
  }

  async refresh(): Promise<void> {
    if (loginService.isLogin) {
      const userInfo = await atom.getMainUserInfo();
      if (userInfo) {
        this.type = userInfo.type as AccountType;
        this.nick = userInfo.nick || '';
        this.headurl = removeHttp(userInfo.headurl);
        const vuid = (this.type === AccountType.qq && Cookie.get('vqq_vuserid')) || Cookie.get('vuserid') || '';
        this.vuid = parseInt(vuid, 10);
      }
    } else {
      this.nick = '';
      this.headurl = '';
      this.type = AccountType.notlogin;
      this.id = '';
      this.vuid = 0;
    }
  }
}

const userService = Vue.observable(new UserService());
export default userService;
